var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateChannelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 5.96638C14.9502 5.95805 14.8919 5.95805 14.8419 5.96638C13.6919 5.92472 12.7752 4.98305 12.7752 3.81638C12.7752 2.62472 13.7335 1.66638 14.9252 1.66638C16.1169 1.66638 17.0752 2.63305 17.0752 3.81638C17.0669 4.98305 16.1502 5.92472 15.0002 5.96638Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1418 12.0332C15.2834 12.2248 16.5418 12.0248 17.4251 11.4332C18.6001 10.6498 18.6001 9.36652 17.4251 8.58318C16.5334 7.99152 15.2584 7.79151 14.1168 7.99151",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97475 5.96638C5.02475 5.95805 5.08308 5.95805 5.13308 5.96638C6.28308 5.92472 7.19975 4.98305 7.19975 3.81638C7.19975 2.62472 6.24142 1.66638 5.04975 1.66638C3.85808 1.66638 2.89975 2.63305 2.89975 3.81638C2.90808 4.98305 3.82475 5.92472 4.97475 5.96638Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83304 12.0332C4.69137 12.2248 3.43304 12.0248 2.54971 11.4332C1.37471 10.6498 1.37471 9.36652 2.54971 8.58318C3.44137 7.99152 4.71637 7.79151 5.85804 7.99151",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 12.1914C9.95014 12.183 9.89181 12.183 9.84181 12.1914C8.69181 12.1497 7.77515 11.208 7.77515 10.0414C7.77515 8.84969 8.73348 7.89136 9.92514 7.89136C11.1168 7.89136 12.0751 8.85803 12.0751 10.0414C12.0668 11.208 11.1501 12.158 10.0001 12.1914Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57528 14.8161C6.40028 15.5994 6.40028 16.8827 7.57528 17.6661C8.90861 18.5577 11.0919 18.5577 12.4253 17.6661C13.6003 16.8827 13.6003 15.5994 12.4253 14.8161C11.1003 13.9327 8.90861 13.9327 7.57528 14.8161Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateChannelIcon);
export default __webpack_public_path__ + "static/media/create-channel-icon.ddc22a90757ce85f0c55fb1be8e550b1.svg";
export { ForwardRef as ReactComponent };